import { t } from '../i18n';

export interface PhoneValidationResult {
  isValid: boolean;
  errorMessage?: string;
  phoneDigits?: string;
}

/**
 * 验证手机号格式和长度
 * @param phone 手机号（可能包含非数字字符，可能为 undefined 或 null）
 * @param countryCode 国家区号（如 '+86' 或 '+1'）
 * @returns 验证结果
 */
export function validatePhoneNumber(
  phone: string | undefined | null,
  countryCode: string
): PhoneValidationResult {
  // 1. 检查是否为空
  const phoneTrimmed = phone?.trim() || '';
  if (!phoneTrimmed) {
    return {
      isValid: false,
      errorMessage: t('pages.login.phoneNumberRequired')
    };
  }

  // 2. 检查是否包含非数字字符
  if (!/^\d+$/.test(phoneTrimmed)) {
    return {
      isValid: false,
      errorMessage: t('login.phone.invalid')
    };
  }

  // 3. 根据国家区号验证长度
  const expectedLength = countryCode === '+86' ? 11 : 10; // CN 11 digits, US 10 digits
  if (phoneTrimmed.length !== expectedLength) {
    return {
      isValid: false,
      errorMessage: t('login.phone.invalid')
    };
  }

  return {
    isValid: true,
    phoneDigits: phoneTrimmed
  };
}

